
require("../../../../Heading/Heading.st.css.js");
require("../../../../Foundation/stylable/typography.st.css.js");
const { classesRuntime, statesRuntime } = require("./../../../../stylable-cjs-runtime.js");



var _namespace_ = "wds_1_177_0_BrandHeading";
var _style_ = classesRuntime.bind(null, _namespace_);

module.exports.cssStates = statesRuntime.bind(null, _namespace_);
module.exports.style = _style_;
module.exports.st = _style_;

module.exports.namespace = _namespace_;
module.exports.classes = {"root":"wds_1_177_0_BrandHeading__root","heading-h1":"wds_1_177_0_StylableTypography__heading-h1","heading-h2":"wds_1_177_0_StylableTypography__heading-h2"};
module.exports.keyframes = {}; 
module.exports.layers = {};
module.exports.containers = {};
module.exports.stVars = {}; 
module.exports.vars = {}; 




